import { render } from "./CommonEmployeeCard.vue?vue&type=template&id=d73c3a1c"
import script from "./CommonEmployeeCard.vue?vue&type=script&lang=js"
export * from "./CommonEmployeeCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\payroll-system\\dashboards\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__